import { render, staticRenderFns } from "./_comparativo.tab.vue?vue&type=template&id=571065d8&scoped=true"
import script from "./_comparativo.tab.vue?vue&type=script&lang=js"
export * from "./_comparativo.tab.vue?vue&type=script&lang=js"
import style0 from "./_comparativo.tab.vue?vue&type=style&index=0&id=571065d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571065d8",
  null
  
)

export default component.exports